import { root } from './accept';

export const accept = {
  ...root,
};
